import { fetchAssetById, fetchBeaconById, searchAssets, searchBeacon } from "@/apiCalls/apiCalls"
import { Assets } from "@/pages/assets/AssetColumns"
import { useDebounce } from "@/utils/DebounceHook"
import { errorNotification } from "@/utils/Notification"
import { Form, Select } from "antd"
import { useEffect, useState } from "react"
import { Beacons } from "./BeaconColumns"
import { useLocation, useNavigate } from "react-router-dom"
import useAxiosPrivate from "@/context/UseAxiosPrivate"


const { Option } = Select;

interface SearchBarProps {
    setData: (data: any[]) => void
    originalData: any[]
}
const BeaconSearchBar: React.FC<SearchBarProps> = ({ setData, originalData }) => {
    const [searchTerm, setSearchTerm] = useState('')
    const [dataToDisplay, setDataToDisplay] = useState(originalData)
    const [dataOptions, setDataOptions] = useState([])
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()

    const searchItems = () => {
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get(`/api/v1/beacons/search?query=${searchTerm}`, {
            signal: controller.signal
        }).then((response) => {
            if (isMounted) {
                setDataToDisplay(response.data.data);
            }
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    }
    useDebounce(searchTerm, 50, searchItems)

    useEffect(() => {
        const updatedOptions: any = dataToDisplay.map((data: Beacons) => ({
            label: data.cid,
            value: data.id

        }));
        setDataOptions(updatedOptions);
    }, [dataToDisplay])

    const filterOptions = (inputValue: string, option: any) => {
        const { label, loanId, beacon_cid } = option;
        return (
            (label && label.toLowerCase().includes(inputValue.toLowerCase()))

        )
    }

    const getBeaconById = async (beaconId: any) => {
        let isMountedR = true;
        const controllerRole = new AbortController()

        const fetchDatadata = async (beaconId: any) => {
            isMountedR = true;
            try {
                let res: any = await axiosPrivate.get(`/api/v1/beacons/${beaconId}`, {
                    signal: controllerRole.signal
                })
                const data = res.data.data
                return data && data.length > 0 ? data[0] : {}

            } catch (err: any) {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
                return {}
            }
        }
        const cleanup = () => {
            isMountedR = false;
            controllerRole.abort();
        };
        const result2 = await fetchDatadata(beaconId)
        cleanup()
        return result2;
    }

    const handleItemSelect = async (value: any) => {
        let results: any
        const beacons = originalData.find((p: any) => p.id === value)
        if (beacons !== undefined) {
            results = beacons
        } else {
            results = await getBeaconById(value)
        }
        setData([results])
    }

    const handleItemChange = (value: any) => {
        setSearchTerm(value)
    }
    return (
        <>
            <Select
                placeholder="Search..."
                showSearch
                filterOption={filterOptions}
                onSearch={handleItemChange}
                className="w-[200px]"
                onSelect={handleItemSelect}
            >
                {dataOptions.map((option: any) => (
                    <Option
                        key={option.value}
                        value={option.value}
                        label={option.label}
                        loanId={option.loanId}
                        customer_name={option.customer_name}
                        beacon_cid={option.beacon_cid}
                        product_name={option.product_name}
                    >
                        {option.label}
                    </Option>

                ))}

            </Select>

        </>
    )
}

export default BeaconSearchBar